import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import Brand from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function PortalHeader({ right }) {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  return (
    <header className="glass sticky top-0 z-30 border-b border-border">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3.5">
        <button onClick={() => navigate(user?.role === "admin" ? "/admin" : "/dashboard")}>
          <Brand />
        </button>
        <div className="flex items-center gap-3">
          {right}
          {user && (
            <span className="hidden text-sm text-muted-foreground sm:block">
              {user.name} <span className="font-mono-label text-[10px]">· {user.customer_id}</span>
            </span>
          )}
          <Button variant="outline" size="sm" data-testid="logout-btn" onClick={() => { logout(); navigate("/"); }}>
            <LogOut className="mr-1.5 h-4 w-4" /> Log out
          </Button>
        </div>
      </div>
    </header>
  );
}
